import { useNavigate } from "react-router-dom";
import { ICON_OCT_VERIFIED } from "src/helpers";
import { MAIN_ROUTES_CONST } from "src/navigations/modules";
import { Button } from "src/shadcn/components/ui";
import { ImageOff } from "lucide-react";

export interface EpcItemData {}

const ListItem = (data: any) => {
  const navigate = useNavigate();

  return (
    <div className="grid gap-2 rounded-xl overflow-hidden border p-4">
      <div className="bg-gray-200 h-full w-full row-span-2 relative">
        {data?.imgUrl ? (
          <img src={data?.imgUrl} style={{ height: "250px", width: "100%" }} alt="data?.imgUrl" />
        ) : (
          <div className="h-[250px] w-100 flex justify-center items-center ">
            <div className="flex flex-col items-center space-y-2">
              <ImageOff className="text-gray-400" size={24} />
              <span className="text-xs">No Content</span>
            </div>
          </div>
        )}
        <div className="flex justify-between items-end mb-2 absolute bottom-0 w-full px-2">
          <div className="uppercase text-xs "># dsdasd2131</div>
          <div>
            <div className="flex items-center  space-x-1 bg-green-50 p-1 border border-green-500 rounded-full ">
              <img src={ICON_OCT_VERIFIED} style={{ height: "20px" }} alt="ICON_OCT_VERIFIED" />
              <span className="text-xs">OCT Verified</span>
            </div>
          </div>
        </div>
      </div>
      <div className="h-full w-full py-4 px-2 ">
        <div className="flex justify-between  mb-2">
          <div>
            <div className="text-gray-400 text-sm">Property Type</div>
            <div className="font-bold text-xl">{data?.propertyType}</div>
          </div>
          <div>
            <div className="text-gray-400 text-xs">Roof Area</div>
            <div className="font-bold text-md text-end">{data?.availableRoofArea} </div>
          </div>
        </div>
        <div className="flex justify-between  mb-2">
          <div>
            <div className="text-gray-400 text-sm">Avg. Load</div>
            <div className="font-bold text-xl">{data?.averageLoad}</div>
          </div>
        </div>
        <Button onClick={() => navigate("/" + MAIN_ROUTES_CONST.roof_top_details + "/" + data?._id)} className="w-full">
          See more
        </Button>
      </div>
      {/* <div className='bg-gray-400 h-full w-full'></div> */}
    </div>
  );
};

export default ListItem;
